import { Box, Button, DialogActions, DialogContent, Divider, Typography } from '@mui/material';
import { CustomDialog } from '../../components/CustomDialog';

export interface MyProjectDialogProps {
  open: boolean;
  onClose: () => void;
}

export function MyProjectDialog(props: MyProjectDialogProps) {
  const { open, onClose } = props;
  const handleClose = () => {
    onClose();
  };
  return (
    <CustomDialog
      className="MyProjectDialog-root"
      aria-labelledby="MyProjectDialog"
      open={open}
      maxWidth="md"
      onClose={handleClose}
    >
      <Box
        className="MyProjectDialog-title"
        sx={{
          width: '100%',
          minHeight: 56,
          display: 'flex',
          alignItems: 'center',
          pl: 3,
        }}
      >
        <Typography variant="h5">나의 모델</Typography>
      </Box>
      <Divider />
      <DialogContent>
        <Box sx={{ display: 'flex', p: 5 }}>MyProject Dialog</Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>닫기</Button>
      </DialogActions>
    </CustomDialog>
  );
}
